module.exports = __webpack_public_path__ + "img/v3.4cf55c60.png";